import type { Role } from 'c-entity-types';
import type { PermissionsDiff } from 'c-admin';

type InviteFlag = 'campaign_agency' | 'campaign_reporting';

/**
 * Only one role may be the "invite" role for each invite flag (the role an invited agency user, or
 * an invited report viewer, is given). The flag's checkbox is locked on every other role while one
 * role holds it, and locked everywhere until the role list has loaded (`roles` null).
 */
export const inviteFlagLocked = (
    roles: Pick<Role, 'id' | 'invite_type'>[] | null,
    roleId: number,
    flag: InviteFlag,
): boolean => {
    if (roles == null) return true;
    const holders = roles.filter(r => r.invite_type[flag] === true);
    if (holders.length === 0) return false;
    return roleId !== holders[0].id;
};

/** Save stays disabled until something about the role has changed. */
export const roleSaveDisabled = ({
    role,
    diff,
    saving,
    name,
    campaignAgencyInvite,
    reportInvite,
}: {
    role: Pick<Role, 'name' | 'invite_type'> | null | undefined;
    diff: PermissionsDiff;
    saving: boolean;
    name: string | undefined;
    campaignAgencyInvite: boolean | undefined;
    reportInvite: boolean | undefined;
}): boolean => {
    const someDiff = diff.added.length > 0 || diff.removed.length > 0;
    const nameChanged = name !== role?.name;
    const inviteChanged = campaignAgencyInvite !== role?.invite_type?.campaign_agency;
    const reportInviteChanged = reportInvite !== role?.invite_type?.campaign_reporting;

    return !(someDiff || saving || nameChanged || inviteChanged || reportInviteChanged);
};
